import {createAction, handleActions} from "redux-actions";
import createRequestSaga, {createRequestActionTypes} from "../lib/createRequestSaga";
import * as fileAPI from "../lib/api/file";
import { takeEvery, takeLatest } from 'redux-saga/effects';

const INITIALIZE_FORM = 'file/INITIALIZE_FORM';
const SET_LOADING = 'file/SET_LOADING';
const SET_FILE = 'file/SET_FILE';
const SET_INT_FILE = 'file/SET_INT_FILE';
const SET_BIZ_FILE = 'file/SET_BIZ_FILE';
const SET_RENT_FILE = 'file/SET_RENT_FILE';
const SET_ETC_FILE = 'file/SET_ETC_FILE';
const SET_KOGNR_ETC_FILE = 'file/SET_KOGNR_ETC_FILE';
const ADD_BOARD_FILE_LIST = 'file/ADD_BOARD_FILE_LIST';
const DELETE_BOARD_FILE_LIST = 'file/DELETE_BOARD_FILE_LIST';
const CLEAR_BOARD_FILE_LIST = 'file/CLEAR_BOARD_FILE_LIST';
const [UPLOAD, UPLOAD_SUCCESS, UPLOAD_FAILURE] = createRequestActionTypes('file/UPLOAD');
const [KOGNR_FILE_UPLOAD, KOGNR_FILE_UPLOAD_SUCCESS, KOGNR_FILE_UPLOAD_FAILURE] = createRequestActionTypes('file/KOGNR_FILE_UPLOAD');
const [UPLOAD_RENT, UPLOAD_RENT_SUCCESS, UPLOAD_RENT_FAILURE] = createRequestActionTypes('file/UPLOAD_RENT');
const [UPLOAD_CHECK, UPLOAD_CHECK_SUCCESS, UPLOAD_CHECK_FAILURE] = createRequestActionTypes('file/UPLOAD_CHECK');

export const setLoading = createAction(SET_LOADING, flag => flag);
export const setFile = createAction(SET_FILE, file => file);
export const setIntFile = createAction(SET_INT_FILE, file => file);
export const setBizFile = createAction(SET_BIZ_FILE, file => file);
export const setRentFile = createAction(SET_RENT_FILE, file => file);
export const setEtcFile = createAction(SET_ETC_FILE, file => file);
export const setKognrEctFile = createAction(SET_KOGNR_ETC_FILE, file => file);
export const addBoardFileList = createAction(ADD_BOARD_FILE_LIST, file => file);
export const deleteBoardFileList = createAction(DELETE_BOARD_FILE_LIST, file => file);
export const clearBoardFileList = createAction(CLEAR_BOARD_FILE_LIST, item => item);
export const uploadFile = createAction(UPLOAD, ({file, targetName}) => ({file, targetName}));
export const kognrUploadFile = createAction(KOGNR_FILE_UPLOAD, ({data}) => ({data}));
export const uploadAndCheckFile = createAction(UPLOAD_CHECK, ({file, stdYear, targetName}) => ({file, stdYear, targetName}));
export const uploadRentFile = createAction(UPLOAD_RENT, ({file}) => ({file}));
export const initializeFileForm = createAction(INITIALIZE_FORM, form => form);

const fileSaga = createRequestSaga(UPLOAD, fileAPI.fileUpload);
const fileRentSaga = createRequestSaga(UPLOAD_RENT, fileAPI.rentFileUpload);
const kognrFileUploadSaga = createRequestSaga(KOGNR_FILE_UPLOAD, fileAPI.kognrFileUpload);
const fileCheckSaga = createRequestSaga(UPLOAD_CHECK, fileAPI.fileUploadAndCheck);
export function* uploadSaga() {
    yield takeEvery(UPLOAD, fileSaga);
    yield takeEvery(UPLOAD_RENT, fileRentSaga);
    yield takeEvery(KOGNR_FILE_UPLOAD, kognrFileUploadSaga);
    yield takeLatest(UPLOAD_CHECK, fileCheckSaga);
}

const initialState = {
    file: null,
    intFile: null,
    bizFile: null,
    etcFile: null,
    kognrEtcFile: null,
    rentFile: null,
    checkResult: '',
    isUpload: false,
    isProcess: false,
    processEnd: false,
    boardFileList: []
};

const file = handleActions(
    {
        [INITIALIZE_FORM]: (state, {payload: data}) => ({
            ...state,
            initialState
        }),
        [SET_LOADING]: (state, action) => ({
            ...state,
            isProcess: action.payload
        }),
        [SET_FILE]: (state, {payload: file}) => ({
            ...state,
            file,
            checkResult: '',
            isProcess: file !== null ? true : false,
            isUpload: false
        }),
        [SET_INT_FILE]: (state, {payload: file}) => ({
            ...state,
            intFile: file,
            // checkResult: '',
            // isProcess: file !== null ? true : false,
            isUpload: false
        }),
        [SET_BIZ_FILE]: (state, {payload: file}) => ({
            ...state,
            bizFile: file,
            // checkResult: '',
            // isProcess: file !== null ? true : false,
            isUpload: false
        }),
        [SET_RENT_FILE]: (state, {payload: file}) => ({
            ...state,
            rentFile: file,
            // checkResult: '',
            // isProcess: file !== null ? true : false,
            isUpload: false
        }),
        [SET_ETC_FILE]: (state, {payload: file}) => ({
            ...state,
            etcFile: file,
            // checkResult: '',
            // isProcess: file !== null ? true : false,
            isUpload: false
        }),
        [SET_KOGNR_ETC_FILE]: (state, {payload: file}) => ({
            ...state,
            kognrEtcFile: file,
            // checkResult: '',
            // isProcess: file !== null ? true : false,
            isUpload: false
        }),
        [ADD_BOARD_FILE_LIST]: (state, action) => {
            const newState = {
                ...state,
                boardFileList: [...state.boardFileList, action.payload]
            };
            return newState;
        },
        [DELETE_BOARD_FILE_LIST]: (state, action) => {
            const newState = {
                ...state,
                boardFileList: state.boardFileList.filter(item => item !== action.payload)
            };
            return newState;
        },
        [CLEAR_BOARD_FILE_LIST]: (state, action) => {
            const newState = {
                ...state,
                boardFileList: []
            };
            return newState;
        },
        [UPLOAD_SUCCESS]: (state, {payload: data}) => ({
            ...state,
            isUpload: true,
            isProcess: false
        }),
        [UPLOAD_FAILURE]: (state, {payload: error}) => ({
            ...state,
            isUpload: false,
            isProcess: false
        }),
        [UPLOAD_RENT_SUCCESS]: (state, {payload: data}) => ({
            ...state,
            isUpload: true,
            isProcess: false
        }),
        [UPLOAD_RENT_FAILURE]: (state, {payload: error}) => ({
            ...state,
            isUpload: false,
            isProcess: false
        }),
        [KOGNR_FILE_UPLOAD_SUCCESS]: (state, {payload: data}) => ({
            ...state,
            isUpload: true,
            isProcess: false,
            processEnd: true
        }),
        [KOGNR_FILE_UPLOAD_FAILURE]: (state, {payload: error}) => ({
            ...state,
            isUpload: false,
            isProcess: false,
            processEnd: false
        }),
        [UPLOAD_CHECK_SUCCESS]: (state, {payload: data}) => ({
            ...state,
            isUpload: true,
            checkResult: data,
            isProcess: false
        }),
        [UPLOAD_CHECK_FAILURE]: (state, {payload: error}) => ({
            ...state,
            isUpload: false,
            isProcess: false
        })
    },
    initialState
);

export default file;
